var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.formValue[_vm.innerConfig.prop].length ? _c('div', { staticClass: "multi-line-text" }, _vm._l(_vm.formValue[_vm.innerConfig.prop], function (item, index) {
    return _c('span', { key: index }, [_vm._v(_vm._s(item))]);
  }), 0) : _c('div', [_vm._v("-")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };